import { useNavigate } from 'react-router-dom';
import './index.scss';
import EvaluatorApprovalNotFoundSvgComponent from '../../assets/svg-components/not-found/evaluator-approval';

interface ActivitiesEvaluatorTaskNotfoundProps {
  hasLegacyTask?: boolean;
}

export default function ActivitiesEvaluatorTaskNotfound({ hasLegacyTask }: ActivitiesEvaluatorTaskNotfoundProps) {
  const navigate = useNavigate();

  const handleRedirectToLegacy = () => {
    const queryString = window.location.search;
    navigate(`/repository/legacy-task/evaluator${queryString}`);
  };

  return (
    <>
      <div className="new-not-found-wrap">
        <div className="new-not-found-wrap__details">
          <div className='not-found-image img-fluid not-found-image-executor-task'>
            <EvaluatorApprovalNotFoundSvgComponent />
          </div>
          <p className="no-data-found-text">
          {hasLegacyTask 
            ? "No approval pending for selected timeframe or filters. However, there are tasks available in the Legacy Tasks."
            : "No approval pending for selected timeframe or filters. Please change date or filter criteria to view information."
          }
          </p>

          {hasLegacyTask && (
          <button 
            className="btn btn-primary mt-3 p-2"
            onClick={handleRedirectToLegacy}
          >
            View Legacy Tasks
          </button>
        )}
        </div>
      </div>
    </>
  );
}


